
import { utilityService } from "@services/utility.service";
import { Vue, Component, Prop } from "vue-property-decorator";
import { buildURL } from "@utils/build-url";
import { fullAddress } from "@utils/user-helpers";
import { ciTrackingService } from "@services/ci-tracking.service";
import DirectMessageModal from "@components/messaging/direct-message.vue";

@Component({
  name: "ci-user-tile",
  components: {
    "ci-direct-message-modal": DirectMessageModal,
  },
})
export default class extends Vue {
  @Prop({ required: true }) user!: UsersV2.Tile;
  @Prop({ default: "p-3" }) paddingClass!: string;
  @Prop({ default: false }) withBorder!: boolean;
  @Prop({ default: true }) withSendMessage!: boolean;
  @Prop({ default: true }) withProfileLink!: boolean;
  @Prop({ default: false }) linkDisabled!: boolean;
  @Prop({ default: true }) displayLabel!: boolean;
  @Prop({ default: false }) withContext!: boolean;
  @Prop({ default: true }) displayTileName!: boolean;
  @Prop({ default: false }) advisorTile!: boolean;
  @Prop({ default: "" }) linkClass!: string;
  @Prop({ default: "xl" }) size!: "sm" | "md" | "lg" | "xl" | "xxl" | "xxxl" | "xxxxl";
  @Prop({ default: () => ({}) }) public additionalTracking!: Nullable<{ [id: string]: string }>;

  // Use a UUID for the modal ID to avoid duplicate modals when this component is used multiple times on the same page
  public uuid = utilityService.guid();

  public get classes(): string {
    const borderClass = this.withBorder ? "with-tile-border" : "";
    const tileClass = this.advisorTile ? "advisor_tile" : "";
    const classes = [this.paddingClass, borderClass, tileClass].filter((el) => el !== "");

    return classes.join(" ");
  }

  public get userSignedIn(): boolean {
    return this.$user.signedIn;
  }

  public get modalId(): string {
    if (!this.$user.signedIn) {
      return "modal-login";
    }

    return `modal-direct-message--${this.uuid}`;
  }

  public get linkWithTracking(): string {
    if (!this.user.url) return "";
    if (!this.additionalTracking) return this.user.url;

    return buildURL(this.user.url, { searchParams: this.additionalTracking });
  }

  public get userLink(): string | boolean {
    return this.withSendMessage || this.linkDisabled ? false : this.linkWithTracking;
  }

  public get tileHtmlComponent(): string {
    return this.withSendMessage ? "div" : "ci-router-link";
  }

  public get location(): string {
    return fullAddress(this.user);
  }

  public get generalLabel(): Nullable<string> {
    if (this.user.advisor_label) return this.user.advisor_label;
    if (!this.user.general_label) return null;

    return `ui.views.users.show.types.${this.user.general_label}`;
  }

  public trackOpenMessageSendModal(): void {
    ciTrackingService.trackClick("ButtonSendMessage", this.user.id.toString(), "UserTile");
  }
}
